import { encryptObject } from "@/helpers/noncehelper";
import { appendStoreIdToItems } from "@/helpers/storageHelper";
import { addAllItemToShoppingList, addToCartItem, deleteCustomShoppingList, fetchManagementList, getManagementListItems, moveListItems, substituteItemsList, updateCustomShoppingList, updateShoppingShoppedItem } from "@/services/products";
import { fetchSafeJson } from "@/utils/apiResponse";
import { Meta } from "@/utils/types/manageList";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { SubstituteItem } from "..";

// export const bulkInsertionProductCategories = createAsyncThunk(
//   "inset_allshoppinglist",
//   async (payload: { listArray: [] }, {rejectWithValue}) => {
//     const {userToken, ...rest} = payload;
//     const data = await fetchManagementList(
//       "/productsManagement/bulkInsertion",
//       userToken,
//       encryptObject(payload)
//     );
//     // return data;
//     if(data?.status != 400){
//       return data;
//     }else {
//       return rejectWithValue(
//         data?.details?.details
//       );
//     }
//   }
// );

export const getListItemsAction = createAsyncThunk(
  "api/productsManagement/getListData",
  async (payload: {categoryId: string, userToken: string, storeId: string }, {rejectWithValue}) => {
    const data = await getManagementListItems(
      encryptObject(payload)
    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
    const modifiedJsonData = {
      data : {
        ...safeJson.response?.data,
        items: await appendStoreIdToItems(safeJson.response?.data?.items, payload.storeId ),
      }
    };
    if(modifiedJsonData){
      return modifiedJsonData;
    }
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const addListItemsToCart = createAsyncThunk(
  "add_list_to_cart",
  async (payload: {
    categoryId?: number;
    meta?: string;
    itemId: string | number;
    quantity: number;
    listType: string;
    isFavourite: number;
    isShopped?: number;
    userToken: string;
    storeId?: string;
  }, {rejectWithValue}) => {
    // const reqPayload = encrypt(payload);
    const {userToken, ...rest} = payload;
    const data = await addToCartItem(
      encryptObject(payload)

    );
   

    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      if(safeJson?.response?.resultData){
        safeJson.response.resultData.item_id += `_${payload.storeId}`
      }
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const updateCustomList = createAsyncThunk(
  "get_shoppinglist",
  async (payload: {
    
    itemId: string | number | undefined;
    quantity: string | number | undefined;
    itemName: object | undefined;
    shopped: number,
    userToken: string
  }, {rejectWithValue}) => {
    const {userToken, ...rest} = payload;
    const data = await updateCustomShoppingList(
      encryptObject(payload),
    );
  
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const deleteCustomList = createAsyncThunk(
  "delete_shopping_list",
  async (payload: { id: number, userToken: string }, {rejectWithValue}) => {
    const {userToken, ...rest} = payload;
    const data = await deleteCustomShoppingList(
      encryptObject(payload),
    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }

  }
);

export const addAllCustomList = createAsyncThunk(
  "add_all_shopping_list",
  async (payload: { listArray: Array<any> , userToken: string}, {rejectWithValue}) => {
    const {userToken, ...rest} = payload;
    const data = await addAllItemToShoppingList(
      encryptObject(payload),
    );
    
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const updateShoppedItem = createAsyncThunk(
  "update_shooped_item",
  async (payload: { itemId: string, userToken: string }, {rejectWithValue}) => {
    const {userToken, ...rest} = payload;
    const data = await updateShoppingShoppedItem(
      encryptObject(payload),

    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);


export const substituteShopItem = createAsyncThunk(
  "substitute_items",
  async (payload: { userToken:string, categoryId:string,  substituteListData: SubstituteItem[];}, {rejectWithValue}) => {
    const data = await substituteItemsList(
      encryptObject(payload),

    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);

export const moveShopListItems = createAsyncThunk(
  "move_items",
  async (payload: { userToken:string, categoryId:string, items:any}, {rejectWithValue}) => {

    console.log("Testing11",payload)
    const data = await moveListItems(
      encryptObject(payload),

    );
    const safeJson = await fetchSafeJson(data);
    if(safeJson.response?.status != 400){
      return safeJson.response;
    }else {
      return rejectWithValue(
        safeJson.response?.details?.details ? safeJson.response?.details?.details : safeJson.response?.details
      );
    }
  }
);
